import { memo as Memo } from 'react';

//* Component
import Text from '@/components/global/Text';

const LongText = Memo(({ data }) => {
	return data.type === 'subtitle' ? (
		<Text
			tag={'h6'}
			className={`${data.type === 'light' ? 'font-light' : ''} ${data.type === 'bold' ? 'font-bold' : ''} ${data.type === 'subtitle' ? 'font-regular' : ''} font-poppins`}>
			{data.text}
		</Text>
	) : (
		<Text className={`${data.type === 'light' ? 'font-light' : ''} ${data.type === 'bold' ? 'font-bold' : ''} ${data.type === 'subtitle' ? 'font-regular' : ''} font-poppins`}>{data.text}</Text>
	);
});

export default LongText;
